import { PharmacyLabRadiology, PharmacyLabRadiologyControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Atish Bagate
 * **/

interface Params {
    parmacyLabRadiology : PharmacyLabRadiology;
    xTENANTID?: string;
}

export const useCreatePharmacyLabRadiology = ()  => 
    useMutationWithLoading(async (params:Params) => 
    new PharmacyLabRadiologyControllerApi(getConfigObject()).createPharmacyLabRadiology(
        params?.parmacyLabRadiology,
        params?.xTENANTID
    )
    );